import React from "react";
import { ICellRendererParams } from "ag-grid-community";

interface CustomValidationTooltipProps extends ICellRendererParams {
    errorMessage?: string;
}

export const CustomValidationTooltip = (props: CustomValidationTooltipProps) => {
  const { data, errorMessage } = props;
  const element = document.getElementById(`custom-cell-${data.id || data.key}-${props.colDef?.field}`);
  const rect = element?.getBoundingClientRect();
  let top = 0, left = 0, width = 0;

  if (rect && rect.top && rect.height) {
    top = rect.top + rect.height + 15 || 0;
    width = rect.width + 10;
    left = rect.left - 10; // Adjust left position to be near the right edge of the cell
  }
  return (
    <>
      {
        errorMessage && element && <div className="tooltip-ww" style={{ border: '1px solid #aaa', padding: '12px 15px', backgroundColor: '#fff', position: 'fixed', zIndex: 1000, top: top, left: left, width: width, borderRadius: 5, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
          {errorMessage}
        </div>
      }
    </>
  );
};